// rangeCalculatorAlgorithm.js

const rangeCalculator = (latitude, longitude, radius) => {
    if (!latitude || !longitude || !radius) return null;

    const earthRadius = 6371000; // Earth's radius in meters

    const deltaLat = radius / earthRadius;
    const deltaLon = radius / (earthRadius * Math.cos((Math.PI * latitude) / 180));

    const minLatitude = latitude - (deltaLat * 180 / Math.PI);
    const maxLatitude = latitude + (deltaLat * 180 / Math.PI);
    const minLongitude = longitude - (deltaLon * 180 / Math.PI);
    const maxLongitude = longitude + (deltaLon * 180 / Math.PI);

    return {
        minLatitude,
        maxLatitude,
        minLongitude,
        maxLongitude,
    };
};

export default rangeCalculator;